import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["itemId", "isHeader"];
import React from 'react';
import { Checkbox } from '@lumahealthhq/ui-core';
import { useSelectedItems } from '../../contexts/SelectedItemsContext';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @ignore - internal component.
 */
function CheckboxCellWrapped(_ref) {
  let {
      itemId
    } = _ref,
    checkboxProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    getTitleCheckboxProps,
    getCheckboxProps
  } = useSelectedItems();
  const props = React.useMemo(() => itemId ? getCheckboxProps(itemId) : getTitleCheckboxProps(), [getCheckboxProps, getTitleCheckboxProps, itemId]);
  return /*#__PURE__*/_jsx(Checkbox, _extends({}, props, checkboxProps));
}
const CheckboxCell = /*#__PURE__*/React.memo(CheckboxCellWrapped);
export default CheckboxCell;